module.exports = __webpack_public_path__ + "img/guide.2bf3fa2c.svg";